// @flow

import { useCallback, useState } from 'react';

/**
 * Hook to toggle a boolean value
 *
 * @param {Boolean} initialValue
 */
export default function useToggle(initialValue?: boolean = false) {
  const [isToggleOn, setIsToggleOn] = useState(initialValue);

  const toggle = useCallback(() => setIsToggleOn(!isToggleOn), [isToggleOn]);

  return [isToggleOn, toggle];
}
